"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TagList',
    tag: 'c-TagList__item',
    loadmore: 'c-TagList__loadmore',
    cards: {
        container: 'c-TagList__cards',
        head: 'c-TagList__cards-header',
        isEmpty: 'c-TagList__cards--empty'
    },
    collections: {
        container: 'c-TagList__collections'
    },
    empty: {
        message: 'c-TagListEmpty__message',
        reset: 'c-TagListEmpty__reset'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
        minWidth: '20%'
    },
    _a[exports.CSS.cards.container] = {
        overflowY: 'auto',
        height: '100%'
    },
    _a[exports.CSS.cards.isEmpty] = {
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center'
    },
    _a[exports.CSS.loadmore] = {
        width: '100%',
        display: 'flex',
        'justify-content': 'center'
    },
    _a[exports.CSS.cards.head] = {
        display: 'flex',
        justifyContent: 'space-around',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4
    },
    _a[exports.CSS.empty.reset] = {
        cursor: 'pointer',
        color: theme_1.DefaultTheme.color.accent
    },
    _a);
//# sourceMappingURL=tag.list.style.js.map